// extracted by mini-css-extract-plugin
export var col = "index-module--col--dZvMI";
export var cols = "index-module--cols--CUz6W flex";
export var iconWrap = "index-module--iconWrap--HqDta util-module--iconWrap--a7crv flex";
export var mqMaxMd = "screen and (max-width: 48em)";
export var mqMinMd = "screen and (min-width: 48em)";